import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  TablePagination,
  Grid,
  Container,
  Typography,
  Select,
  Box,
  Skeleton,
  FormControl,
  Autocomplete,
  Checkbox,
  Button,
  IconButton,
  InputLabel,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useUserProfileQuery, useAppUpdateMutation, useUpdateProcessMutation, useGetUserAccessQuery } from '../services/dvagent';
import { getToken, storeAdmin, removeToken } from '../services/LocalStorageService';
import Iconify from '../components/iconify';
import { Toaster } from '../sections/@dashboard/attributes';  


function formatDate(dateString) {
  const date = new Date(dateString);
  const formattedDate = date.toLocaleDateString('en-US', {
    month: 'long',
    day: '2-digit',
    year: 'numeric'
  });
  const formattedTime = date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit'
  });
  const ampm = date.getHours() >= 12 ? 'PM' : 'AM';
  return `${formattedDate} ${formattedTime} `;
}



export default function DeviceAppUpdate() {

  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [haveDeviceAppUpdateAccess, setHaveDeviceAppUpdateAccess] = useState(false);
  const [devices, setDevices] = useState(location.state.checkedRows);
  const [deviceAppUpdate] = useAppUpdateMutation();
  const [updateProcess] = useUpdateProcessMutation();
  const [open, setOpen] = useState(false);
  const { data: userData, isSuccess: userIsSuccess } = useUserProfileQuery(getToken());
  const { data:userAccessData, isSuccess:userAccessIsSuccess, error:userAccessError } = useGetUserAccessQuery({"token":getToken(), "id":location.state.property_id, "location":location});
  const [searchText, setSearchText] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [message, setMessage] = useState("");
  const [logo, setLogo] = useState("");
  const [startProcess, setStartProcess] = useState(false);
  const [processId, setProcessId] = useState(0);
  const [Scheduled, setScheduled] = useState("");
  const [date, setDate] = useState("");
  const paginationModel = { page: 0, pageSize: 10 };
  const [process, setProcess] = useState([]);
  const [timeoutId, setTimeoutId] = useState(null);
  const [toasterData, setToasterData] = useState({
    trigger: false,
    status: true,
    symbol: '✔',
    message: '',
  });

  if (userData && userIsSuccess) {
    storeAdmin((userData.data[0].is_superuser).toString());
  }

  const handleClose = () => {
    setOpen(false);
  };

  const filteredData = devices.filter(
    (item) =>
      item.name.toLowerCase().includes(searchText.toLowerCase()) ||
      item.serialNumber.toLowerCase().includes(searchText.toLowerCase()) ||
      item.status.toLowerCase().includes(searchText.toLowerCase()) ||
      item.tags.some(tag => tag.toLowerCase().includes(searchText.toLowerCase()))
  );

  const suggestions = Array.from(
    new Set(devices.flatMap((item) => item.tags.map((tag) => tag)))
  );
  suggestions.sort((a, b) => a.localeCompare(b));

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleUpdateProcess = async (val) => {
    const actualData = {
      propertyId: location.state.location.state.property_id,
      networkId: location.state.location.state.network_id,
      id: 0,
      token: getToken()
    };
    try {
      const res = await updateProcess(actualData);
      if (res.data && res.data.process.length) {
        setProcess(res.data.process)
        let maxIdObject = res.data.process[0];
        if (val === 0) {
          for (let i = 1; i < res.data.process.length; i += 1) {
            if (res.data.process[i].id > maxIdObject.id) {
              maxIdObject = res.data.process[i];
            }
          }
        } else {
          for (let i = 1; i < res.data.process.length; i += 1) {
            if (res.data.process[i].id === val) {
              maxIdObject = res.data.process[i];
            }
          }
        }
        if (maxIdObject.data.length) {
          setDevices(maxIdObject.data);
          setProcessId(maxIdObject.id);
          setScheduled(maxIdObject.scheduled_by);
          setDate(maxIdObject.created_on)
        }
      }
    } catch (e) {
      // setDevices([])
    }
  };

  const handleDeviceAppUpdate = async () => {
    setOpen(false);
    const actualData = {
      data: {
        "name": location.state.location.state.name,
        "property_id": location.state.location.state.property_id,
        "network": location.state.location.state.network_id,
        "devices": location.state.checkedRows
      },
      token: getToken()
    }
    const res = await deviceAppUpdate(actualData);

    if (res.error) {
      if (res.error.status === 400) {
        showToast(false, 'ⓘ', 'Something went wrong, bad request');
      } else if (res.error.status === 401) {
        showToast(false, 'ⓘ', 'Access Denied');
      } else if (res.error.status === 500) {
        showToast(false, 'ⓘ', 'Something went wrong, server error');
      } else if (res.error.status === 404) {
        showToast(false, 'ⓘ', 'Please complete the application information like app version or app id.');
      } else {
        showToast(false, 'ⓘ', 'Something went wrong');
      }
    }
    if (res.data) {
      handleCall(0)
      setStartProcess(true);
      showToast(true, '✔', 'Process started');
      setOpen(false);
    }
    if (res.data === null) {
      handleCall(0)
      setStartProcess(true);
      showToast(true, '✔', 'Process started');
      setOpen(false);
    }
  };

  const handleAskUpdateProcess = () => {
    // if(!haveDeviceAppUpdateAccess) {
    //   showToast(false, 'ⓘ', 'Access Denied');
    //   return
    // }
    setOpen(true);
    setMessage("Are you sure you want to start a app update process?");
    setLogo("../../assets/app/ask.gif");
  }

  const handleCall = (value) => {
    handleUpdateProcess(value);
    const id = setTimeout(() => {
      handleCall(value);
    }, 5000);
    if (timeoutId) {
      clearTimeout(timeoutId)
    }
    setTimeoutId(id);
  };

  useEffect(() => {
    try {
      setHaveDeviceAppUpdateAccess(userAccessData.data.have_device_app_update_access);
    } catch(err) {
      console.log(err)
    }
  }, []);

  useEffect(() => {
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [timeoutId]);

  useEffect(() => {
    if (devices?.length === 0) {
      setStartProcess(true);
      handleCall(0);
    }
  }, [devices?.length])

  const handleScheduledBy = (event) => {
    setProcessId(event.target.value);
    if (timeoutId) {
      clearTimeout(timeoutId);
      setTimeoutId(null);
      handleCall(event.target.value);
    }
  };

  const handleExportToExcel = () => {
    const data = filteredData.map((item, index) => ({
      "S. No.": index + 1,
      "Name": item.name,
      "Serial Number": item.serialNumber,
      "App Version": item.appVersion || '',
      "Status": item.status || '',
      "Process Log": item.process || '',
      "Error Log": item.error || ''
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Devices");

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const excelBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(excelBlob);
    link.download = 'devices.xlsx';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const showToast = (status, symbol, message) => {
    setToasterData({
      trigger: true,
      status,
      symbol,
      message,
    });

    setTimeout(() => {
      setToasterData((prev) => ({
        ...prev,
        trigger: false,
      }));
    }, 5000); 
  };

  const columns = [
    { field: "serial", headerName: "S. No.", width: 100 },
    { field: "name", headerName: "Name", flex: 1, width: 150 },
    { field: "serialNumber", headerName: "Serial Number", flex: 1, width: 150 },
    { 
      field: "appVersion", 
      headerName: "App Version", 
      flex: 1,
      renderCell: (params) => {
        const { appVersion } = params.row;
        return appVersion ? (
          <TableCell sx={{ textAlign: "center" }}>{appVersion}</TableCell>
        ) : (
          <TableCell><Skeleton animation="wave" height={25} width="2000%" /></TableCell>
        );
      }
    },
    { 
      field: "status", 
      headerName: "Status", 
      flex: 1,
      renderCell: (params) => {
        const { status } = params.row;
        return status ? (
          <TableCell
            sx={{
              color: status === 'Failed'
                ? '#FFB7B7'
                : status === 'Success'
                ? '#96C291'
                : '#35374B',
              fontWeight: 'bold',
              textAlign: 'center',
            }}
          >
            {status}
          </TableCell>
        ) : (
          <TableCell><Skeleton animation="wave" height={25} width="2000%" /></TableCell>
        );
      }
    },
    { 
      field: "process", 
      headerName: "Process", 
      flex: 2,
      renderCell: (params) => {
        const { process } = params.row;
        return process ? (
          <TableCell sx={{ textAlign: "center" }}>{process}</TableCell>
        ) : (
          <TableCell><Skeleton animation="wave" height={25} width="2000%" /></TableCell>
        );
      }
    },
    { 
      field: "error", 
      headerName: "Error", 
      flex: 2,
      renderCell: (params) => {
        const { error } = params.row;
        return error ? (
          <TableCell sx={{ textAlign: "center" }}>{error}</TableCell>
        ) : (
          <TableCell><Skeleton animation="wave" height={25} width="2000%" /></TableCell>
        );
      }
    },
  ];
  
  const rows = filteredData.map((row, index) => ({
    ...row,
    serial: index + 1,
  }));

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {message}
        </DialogTitle>
        <DialogContent>
          <Box
            noValidate
            component="form"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              m: 'auto',
              width: 'fit-content',
            }}
          >
            <img width={100} src={logo} alt="logo" />
          </Box>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => handleDeviceAppUpdate()}>
              Yes
            </Button>
            <Button onClick={() => handleClose()}>
              No
            </Button>
        </DialogActions>
      </Dialog>

      <Helmet>
        <title> DV Agent </title>
      </Helmet>
      
      {toasterData.trigger && (
        <Toaster
          trigger={toasterData.trigger}
          status={toasterData.status}
          symbol={toasterData.symbol}
          message={toasterData.message}
        />
      )}

      <Container maxWidth="xxl">
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Box state={location.state.location.state} to="/cloud/devices" component={RouterLink}>
            <img width={40} src="../../assets/back-button.gif" alt="verified" style={{ marginLeft: 4, display: 'inline-block', verticalAlign: 'middle' }} />
          </Box>
          <Typography
            gutterBottom
            variant=""
            component="div"
            sx={{
              color: '#A8A196',
              textAlign: 'left',
              marginLeft: 2,
              paddingBottom: 1,
              fontSize: '1.5rem',
              fontWeight: 'bold',
            }}
          >
            {location.state.location.state.name}
            <Typography variant="" component="div" sx={{ fontSize: 16, color: '#4D4D4D' }}>
              {location.state.location.state.network_name}
            </Typography>
          </Typography>
        </div>

        <Grid container spacing={2}>
          <Grid item xs={9} sm={4} md={4} xl={4} style={{ display: 'flex' }}>
            <FormControl fullWidth>
              <Autocomplete
                freeSolo
                options={suggestions}
                inputValue={searchText}
                onInputChange={(e, newInputValue) => setSearchText(newInputValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search Name/Serial/Floor/Status"
                    variant="outlined"
                    size="small"
                  />
                )}
              />
            </FormControl>
          </Grid>

          {location.state.checkedRows && location.state.checkedRows.length > 0 && !startProcess ? (
            <>
              <Grid item xs={3} sm={3} md={2} xl={2} style={{ display: 'flex' }}>
                <FormControl>
                  <Button
                    onClick={handleAskUpdateProcess}
                    sx={{
                      color: '#FFF',
                      border: 1,
                      borderColor: '#A8A196',
                      bgcolor: '#A8A196',
                      ":hover": {
                        bgcolor: "#7D7463",
                        borderColor: '#7D7463',
                      }
                    }}>
                    Start
                  </Button>
                </FormControl>
              </Grid>
            </>
          ) : (
            <>
              <Grid item xs={3} sm={4} md={3} xl={3} style={{ display: 'flex' }}>
                <FormControl fullWidth size="small">
                  <InputLabel id="demo-select-small-label">Scheduled On</InputLabel>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value={processId}
                    label="Scheduled On"
                    onChange={handleScheduledBy}
                  >
                    {process.slice().reverse().map((item, index) =>
                      <MenuItem value={item.id} key={item.id}>{formatDate(item.created_on)} by {item.scheduled_by}</MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Grid>
            </>
          )}

        </Grid>
        <div>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  {Scheduled ?
                    <TableCell sx={{ color: "#A8A196", background: "#F9FAFB" }} colSpan={7} >Scheduled by <Typography sx={{ color: "#000", fontStyle: "italic" }}>{Scheduled}</Typography><Typography sx={{ color: "#000", fontStyle: "italic" }}>{formatDate(date)}</Typography></TableCell>
                    : <TableCell sx={{ color: "#A8A196", background: "#F9FAFB" }} colSpan={7}>&nbsp;</TableCell>
                  }
                </TableRow>
              </TableHead>

              {loading ? (
                <TableBody>
                  {filteredData.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        No Device Found
                      </TableCell>
                    </TableRow>
                  ) : (
                    <Paper>
                      <DataGrid
                        rows={rows}
                        columns={columns}
                        initialState={{ pagination: { paginationModel } }}
                        pageSizeOptions={[10, 25, 50, 100]}
                        checkboxSelection
                        sx={{
                          border: 0,
                          '& .MuiDataGrid-columnHeaders': {
                            backgroundColor: '#afb3c7', 
                            color: '#A8A196',          
                            fontSize: '16px',          
                            fontWeight: 'bold',        
                          },
                          '& .MuiDataGrid-columnSeparator': {
                            display: 'none',           
                          },
                        }}
                      />
                    </Paper>
                  )}
                </TableBody>
              ) : (
                <TableBody>
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item, index) => (
                    <TableRow key={index}>
                      <TableCell><Skeleton animation="wave" height={25} width="100%" /></TableCell>
                      <TableCell><Skeleton animation="wave" height={25} width="100%" /></TableCell>
                      <TableCell><Skeleton animation="wave" height={25} width="100%" /></TableCell>
                      <TableCell><Skeleton animation="wave" height={25} width="100%" /></TableCell>
                      <TableCell><Skeleton animation="wave" height={25} width="100%" /></TableCell>
                      <TableCell><Skeleton animation="wave" height={25} width="100%" /></TableCell>
                      <TableCell><Skeleton animation="wave" height={25} width="100%" /></TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              )}
            </Table>
          </TableContainer>

          <Grid container spacing={2} mt={1}>
            <Grid item xs={2} sm={2} md={2} xl={2}>
              {Scheduled ?
                <Button
                  component="label"
                  variant="contained"
                  onClick={handleExportToExcel}
                  sx={{
                    color: '#FFF',
                    border: 1,
                    borderColor: '#A8A196',
                    bgcolor: '#A8A196',
                    ":hover": {
                      bgcolor: "#7D7463",
                      borderColor: '#7D7463',
                    }
                  }}
                ><Iconify icon='teenyicons:download-solid' />&nbsp;&nbsp;Export
                </Button>
                : <></>}
            </Grid>
          </Grid>
        </div>
      </Container>
    </>
  );
}